import { getCouncilConfig, isLondonCouncil, LONDON_COUNCILS } from '../councils';

export function londonScopeIsPublic(scope?: string | null): boolean {
  if (!scope || scope === 'london') return Object.values(LONDON_COUNCILS).every(council => council.publicEnabled);
  const council=getCouncilConfig(scope);
  return council?.region === 'london' && council.publicEnabled;
}

export function usesSharedLondonDelivery(scope?: string | null): boolean {
  if (scope === 'london') {
    return Object.values(LONDON_COUNCILS).length === 33 && Object.values(LONDON_COUNCILS)
      .every(council => council.publicEnabled && council.planningDelivery === 'shared');
  }
  const council = scope ? getCouncilConfig(scope) : null;
  return council?.region === 'london' && council.publicEnabled && council.planningDelivery === 'shared';
}

export function usesRetainedLondonDelivery(scope?: string | null): boolean {
  return (scope === 'london' || Boolean(scope && isLondonCouncil(scope))) && !usesSharedLondonDelivery(scope);
}

/** Cached retained records never acquire enrichment capabilities at cutover. */
export function isSourceOnlyPlanningRecord(record?: Record<string, any> | null): boolean {
  if (!record) return false;
  if (record.source_record_only === true || record.release_stage === 'official_records') return true;
  if (!isLondonCouncil(record.source_council)) return false;
  return getCouncilConfig(record.source_council)?.releaseStage === 'official_records' ||
    !usesSharedLondonDelivery(record.source_council) || record.planning_delivery !== 'shared';
}

export function confirmsSharedLondonScope(payload: any, council?: string | null): boolean {
  const expected = council && council !== 'london' ? [council] : Object.keys(LONDON_COUNCILS);
  const scope = payload?.scope;
  return Boolean(scope && scope.country === 'england' && scope.region === 'london' &&
    Array.isArray(scope.public_authorities) && scope.public_authorities.length === expected.length &&
    new Set(scope.public_authorities).size === expected.length &&
    scope.public_authorities.every((slug: unknown) => typeof slug === 'string' && expected.includes(slug)));
}

/** Only common-transport readers call this after HTTP/scope validation. */
export function sharedLondonPlanningRecord(record: any, council?: string | null): Record<string, any> {
  const slug = record?.source_council;
  const reference = typeof record?.reference_no === 'string' ? record.reference_no : '';
  const normalized = reference.replace(/\s/g, '').toUpperCase();
  if (!record || typeof record !== 'object' || Array.isArray(record) || !isLondonCouncil(slug) ||
      !usesSharedLondonDelivery(slug) || (council && council !== 'london' && council !== slug) ||
      !normalized || normalized.length > 140 || normalized.includes(':') || record.application_uid !== `${slug}:${normalized}` ||
      typeof record.source_system !== 'string' || !record.source_system.trim()) {
    throw new Error('Shared London application identity could not be verified');
  }
  return { ...record, planning_delivery: 'shared', source_record_only: record.source_record_only === true || record.release_stage === 'official_records',
    source: 'planning', feed_source: 'planning' };
}
